import { useRoutes } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import LoginRoutes from './LoginRoutes';
import ConfigRoutes from './ConfigRoutes';
import ErrorRoutes from './ErrorRoutes';
import VendorRoutes from './VendorRoutes';
import AdminRoutes from './AdminRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const { user } = useAuth();
  const serviceRoutes = [LoginRoutes, ErrorRoutes];

  const userRoutesValues = {
    user: [AdminRoutes, ConfigRoutes],
    admin: [AdminRoutes, ConfigRoutes],
    manager: [AdminRoutes, ConfigRoutes],
    vendor: [VendorRoutes],
    finance: []
  };
  const currentUserRoutes = user?.role ? userRoutesValues[user?.role] : userRoutesValues['user'];
  console.log('🚀 ~ ThemeRoutes ~ user?.role:', user?.role);
  const routes = useRoutes(currentUserRoutes ? [...serviceRoutes, ...currentUserRoutes] : serviceRoutes);

  return routes;
}
